module.exports = __webpack_public_path__ + "static/media/new.f01994c9.svg";